'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.div.withConfig({
  componentId: 'jspiq5-0'
})(['position:relative;', ' ', ''], function (p) {
  return p.labelDisplay === 'inline' && '\n    width: calc(' + p.theme.inputWidth + ' + 20px);\n    padding-right: 20px;\n  \n    @media (min-width: 768px) {\n      display: inline-block;\n      float: left;\n    }\n  ';
}, function (p) {
  return p.labelDisplay === 'before' && '\n    width: calc(' + p.theme.inputWidth + ' + 20px);\n    padding-right: 20px;\n  \n    @media (min-width: 768px) {\n      width: calc(' + p.theme.inlineLabelWidth + ' + ' + p.theme.inputWidth + ' + 20px);\n    }\n  ';
});